export default __webpack_public_path__ + "static/media/GraceMedia.7d0b2395.png";